import { ALL_BASKET_ERROR_MESSAGES } from 'astra-core/containers/BasketProvider/constants'

import { ERoutes } from 'shared/types/routes'

export const BASKET_ERROR_ACTIONS = {
  [ALL_BASKET_ERROR_MESSAGES.CLIENT_BETS_BLOCK]: [
    { id: '1', action: () => window.LC_API.open_chat_window() }
  ],
  [ALL_BASKET_ERROR_MESSAGES.BETS_INSUFFICIENT_BALANCE]: [
    { id: '1', action: ERoutes.ProfileBalance }
  ],
  [ALL_BASKET_ERROR_MESSAGES.BetCompetitorConstraintError]: [
    {
      id: '1',
      action: () => window.LC_API.open_chat_window()
    }
  ]
}
